import React, { Component } from "react";
import { withRouter } from "react-router";

import AppBar from "../components/AppBar";
import Layout from "../components/layout";
import Map from "../components/Map";
import Dialog from "../components/Dialog";

import { FETCH_INTERVAL } from "../constants";
import examsService from "../services/ExamsService";
import authenticationService from "../services/AuthenticationService";
import LeftSideBar from "../components/LeftSideBar";
import { sendEvent } from "../util/utils";

class HomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: null,
      exams: null,
      filters: [],
      dialog: {},
      stageUnitDistributionByStage: {},
      currentProductionUnit: "HP",
      loading: false,
    };

    this.showDialogFn = this.showDialog.bind(this);
  }

  async componentDidMount() {
    this.startListingEvents();
    this.setState({loading: true});
    await this.startGettingStatusData();
  }

   componentWillUnmount() {
    this.stopGettingData();
    this.stopListingEvents();
  }

  startListingEvents(){
    window.addEventListener("logUserOut", this.logUserOut.bind(this));
    window.addEventListener("show-dialog", this.showDialogFn);
    window.addEventListener("click", this.closeAllDropDown.bind(this));
    window.addEventListener("setCurrentProductionUnit", this.setCurrentProductionUnit.bind(this));
  }

  stopListingEvents(){
    window.removeEventListener("show-dialog", this.showDialogFn);
    window.removeEventListener("click", this.closeAllDropDown.bind(this));
    window.removeEventListener("logUserOut", this.logUserOut.bind(this));
    window.removeEventListener("setCurrentProductionUnit", this.setCurrentProductionUnit.bind(this));
  }

  async startGettingStatusData() {
    examsService.stopGettingDataFrom("getStatus");
    await examsService.startGettingDataFrom(
      "getStatus",
      {},
      this.updateStatus.bind(this),
      FETCH_INTERVAL
    );
  }

  updateStatus(status) {
    this.setState({ status, loading: false },() =>{
      this.buildStageUnitDistributionByStage(status);
      sendEvent("reset-markers", {update: true});
    }); 
  }

  stopGettingData() {
    examsService.stopGettingDataFrom("getStatus");
  }

  buildStageUnitDistributionByStage(status){
    if(status){
      let stageUnitDistributionByStage = {};

      for (const statusIndex in status) {
        if (Object.hasOwnProperty.call(status, statusIndex)) {
          const statusUnit = status[statusIndex];

          for (const stageIndex in statusUnit) {
            if (Object.hasOwnProperty.call(statusUnit, stageIndex) && statusIndex !== "BR") {
              const stageCount = statusUnit[stageIndex];
              stageUnitDistributionByStage[stageIndex] || (stageUnitDistributionByStage[stageIndex] = {});
              stageUnitDistributionByStage[stageIndex][statusIndex] = stageCount;
            }
          } 
        }
      }

      this.setState({stageUnitDistributionByStage: stageUnitDistributionByStage});
    }
  }
  
  setCurrentProductionUnit(event){
    if(event && event.detail){
      this.setState({currentProductionUnit: event.detail});
    }
  }

  logUserOut() {
    try {
      authenticationService.logout();
      this.props.history.replace("/login");
    } catch (error) {
      console.error(`Error when trying to log the user out: ${error.message}`);
    }
  }

  showDialog(dialogData) {
    if (dialogData && dialogData.detail) {
      this.setState({
        dialog: dialogData.detail,
      });
    }
  }

  defaultCloseDialog() {
    this.setState({
      dialog: {},
    });
  }

  closeAllDropDown(e) {
    let ignoreElement = null;

    if(e &&
      e.target &&
      e.target.dataset &&
      e.target.dataset.target){
        ignoreElement = document.getElementById(e.target.dataset.target);
      }

      let clickInside = ignoreElement ? ignoreElement.contains(e.target) : false;

      if (!clickInside) {
        let menu = document.getElementsByClassName("dropdown-menu");
        for (let c = 0; c < menu.length; c++) {
          if (menu[c].classList && menu[c].classList.contains("user-type-menu")) {
            menu[c].classList.remove("user-type-menu");
          }
        }
      }
  }

  render() {
    return (
      <div>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="true"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Titillium+Web:ital,wght@0,300;0,400;0,600;0,700;1,300;1,400;1,600;1,700&display=swap"
          rel="stylesheet"
        />
        {this.state.loading ? <div id="loader" /> : null}
        <Layout
          header={<AppBar />}
          leftSide={
            <LeftSideBar 
              status = {this.state.status}
              exams = {this.state.exams}
              currentProductionUnit = {this.state.currentProductionUnit}
            />
          }
          content={
            <Map
              status={this.state.status}
              exams={this.state.exams}
              stageUnitDistributionByStage={this.state.stageUnitDistributionByStage}
            />
          }
        />
        <Dialog
          title={this.state.dialog.title}
          message={this.state.dialog.message}
          type={this.state.dialog.type}
          show={this.state.dialog.show}
          confirmation={() => {
            return (
              this.state.dialog.confirmation() || this.defaultCloseDialog()
            );
          }}
          closeInternal={() => this.defaultCloseDialog()}
          {...this.state.dialog}
        />
      </div>
    );
  }
}

export default withRouter(HomeView);
